import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {switchMap, debounceTime, distinctUntilChanged, tap, catchError} from 'rxjs/operators';
import {OrderEntryService} from '../../../services/order-entry.service';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { WardService } from 'src/app/services/ward.service';
import { ArrayType } from '@angular/compiler';
import { TestService } from 'src/app/services/test.service';
import { Observable, of } from 'rxjs';
import { Test } from '../test';
import { DoctorService } from 'src/app/services/service.index';
import { SelectionDialog } from '../../utils/group-selection/selection.component';
import { UserService } from 'src/app/services/user.service';
import { DialogPosition, MatDialog } from '@angular/material/dialog';
import { TestsDialog } from '../order-entry/modals/tests.component';
import { LabelsDialog } from '../order-entry/modals/labels.component';
import { NotesDialog } from '../order-entry/modals/notes.component';
import { LabelsInputDialog } from '../order-entry/modals/labels-input.component';
import {MatSnackBar} from '@angular/material/snack-bar';


@Component({
  selector: 'app-order-entry-edit',
  templateUrl: './order-entry-edit.component.html',
  styleUrls: ['./order-entry-edit.component.css']
})
export class OrderEntryEditComponent implements OnInit {

  user;
  group;

  constructor( private route: ActivatedRoute,
               private orderEntryService: OrderEntryService,
               private router: Router,
               private userService: UserService,
               public dialog: MatDialog,
               private fb: FormBuilder,
               private service: WardService,
               private testService: TestService,
               private doctorService: DoctorService,
               private wardService: WardService,
               private snackBar: MatSnackBar) {
     this.createForm();
    

    this.prioritiesLevel = this.orderEntryService.getPriorityLevel();
    this.editPatient = false;

    this.user = this.userService.getUser();
    this.group = this.userService.getActiveGroup('order-entry');


    if( this.group == null) {
      this.dialog.open(SelectionDialog, {
        data: {groupType: 'order-entry'},
        width: '40%',
        disableClose: true 
      });      
      
    } else{
      this.updateData();
    }

    this.userService.updateUser().subscribe(
      (newUser) => {
        this.user = newUser
        this.group = this.userService.getActiveGroup('order-entry');
        this.updateData();

      }
    )
  }

  order: any;
  prioritiesLevel: any;
  selectedId: string;
  selectedWard: string;
  editOrder: FormGroup;
  samplesForm: FormGroup;
  wards: any;
  editPatient: boolean;
  notAllowedTests;

  ngOnInit(): void {

    this.route.paramMap.subscribe(
      params => {
        const id = params.get('id');
        const order = JSON.parse(sessionStorage.getItem(id));

        //sessionStorage.removeItem(id);

        /*order.tests = new Array();
        order.samples.forEach(
          sample => sample.tests.forEach(test => order.tests.push(test))
        )*/
        this.order = order;
        this.editForm(order);

        


      }
    )
    /* this.route.paramMap.pipe(
        switchMap(params => {
          this.selectedId = params.get('id');
          this.selectedWard = params.get('wardId');
          return this.orderEntryService.getOrder(this.selectedId, this.selectedWard);
        })
    ).subscribe((resp) => {
        if (!resp) {
            //this.router.navigate(['/order-entry/search-order']);
        }
        this.order = resp;
        this.editForm(resp);
        console.log(resp);
    });*/

    let ids = this.order.samples.filter(sample=> sample.checkinDate!=null).map(sample => sample.containerId)

    this.testService.getTestsFilteredByContainer(ids).subscribe(
      data => this.notAllowedTests = data
    )
  }

  updateData() {
    this.wards = this.group.wards.sort((a, b) => (a.wardDescription > b.wardDescription) ? 1 : ((b.wardDescription > a.wardDescription) ? -1 : 0));
    this.editOrder.get('ward').setValue('')
  }
    editForm(order) {
      // this.editOrder.patchValue(order.tests);
      this.editOrder.patchValue({
            externalOrderId: order.externalOrderId,
            doctor: order.doctor,
            noteSector: order.noteSector? order.noteSector:'',
            ward: this.wards.filter(
              ward => {
                return (
                  ward.wardId == this.order.wardId &&
                  ward.versionId == this.order.wardVersion
                )
              })[0],
            //ente: order.ente,
            patient: order.patient,
            priorityLevel: order.priorityLevel,
            orderDate: order.orderDate + ":00"

      });
      order.tests.forEach(test => {
            this.testsForm.push(this.fb.group(test));
            this.oldTestsForm.push(this.fb.group(test));

        });

        // this.samplesForm = this.fb.group({
        //     samples: new FormArray([])
        // });
    }
    createForm() {
        this.editOrder = this.fb.group({
            externalOrderId: new FormControl({value:'', disabled:true}),
            orderDate: [{value: '', disabled:true}, Validators.required],
            priorityLevel: [{value: '', disabled:true}, Validators.required],
            doctor: [null, Validators.required],
            ward: ['', Validators.required],
            ente: new FormControl({value: '' , disabled: true}),
            oldTests: new FormArray([], Validators.required),
            tests: new FormArray([], Validators.required),
            addedTests: new FormArray([], Validators.required),
            deletedTests: new FormArray([], Validators.required),
            noteSector: [''],

            patient: this.fb.group({
                id: [''],
                name: ['', Validators.required],
                surname: ['', Validators.required],
                birthdate: [''],
                fiscalCode: ['', Validators.required],
                healthCode: ['', ],
                sex: [''],
                phone: [''],
                email: [''],
                address: [''],
            }),
        });
        this.samplesForm = this.fb.group({
            samples: new FormArray([])
        });
    }


    get testsForm(): FormArray {
      return this.editOrder.get('tests') as FormArray;
    }

    get oldTestsForm(): FormArray {
      return this.editOrder.get('oldTests') as FormArray;
    }

    get addedTestsForm(): FormArray {
      return this.editOrder.get('addedTests') as FormArray;
    }
    
    get deletedTestsForm(): FormArray {
      return this.editOrder.get('deletedTests') as FormArray;
    }

    clearForm() {
        this.testsForm.clear();
        this.editOrder.reset();
    }

    selectTest($event, testInput) {
      $event.preventDefault();
      this.addTest($event.item);
      testInput.value = '';
    }

    // typeahead test
  searching = false;
  searchFailed = false;
  
  tests;

  searchTest = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.testService.getTest(term).then(
          (tests) => {
            this.tests = tests;
            this.searchFailed = tests.length === 0;
          }
        ).catch(
          () => {
            this.searchFailed = true;
            return of([]);
          }
        )
      ),
      tap(() => this.searching = false)
    )

    addTest(test: Test) {
      const search = this.testsForm.controls.findIndex((t) => t.value.id === test.id);
      const searchDeleted = this.deletedTestsForm.controls.findIndex(t => t.value.id == test.id)
      const searchAllowed = this.notAllowedTests.findIndex(t => (t.testId == test.id && t.type == test.type ))
      
      if( searchAllowed > -1 && search == -1 && searchDeleted == -1) {
        this.snackBar.open(`${test.id} no puede ser solicitado porque la muestra ya se está procesando`, 'X');
      }

      if (search === -1 && searchDeleted == -1 && searchAllowed == -1) {
        this.addedTestsForm.push(this.fb.group(test));
      }
    }
  
    removeTest(test, i) {

      const searchAllowed = this.notAllowedTests.findIndex(t => (t.testId == test.value.id && t.type == test.value.type ))
      if( searchAllowed > -1) {
        this.snackBar.open(`${test.value.id} no puede ser eliminado porque la muestra ya se está procesando`, 'X');
      }else{
        this.deletedTestsForm.push(test);
        console.log(this.deletedTestsForm.controls)
        this.testsForm.removeAt(i);
      }

      
    }

    removeNewTest(i) {
      this.addedTestsForm.removeAt(i);
    }

    addOldTest(test ,i){
      this.deletedTestsForm.removeAt(i);
      this.testsForm.push(test);
    }

 

    formatMatches = (value: Test) => value.id + ' - ' + value.specimenId;

    //ENTES
    
    entes: any;

    loadEntes() {
      /* const ward = this.editOrder.get('ward').value;
      if (ward) {
        this.wardService.getEntes(ward).subscribe((resp) => {
          if (resp.length > 0) {
            this.entes = resp;
            this.editOrder.get('ente').enable();
          } else {
            this.entes = [];
            this.editOrder.get('ente').disable();
          }
  
        });
      } */
    }

    // typeahead doctor
  searchingDoctor = false;
  searchFailedDoctor = false;

  formatMatchesDoctor = (value: any) => value ? value.nameSurname + ' - ' + value.nationalId : '';

  searchDoctor = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searchingDoctor = true),
      switchMap(term =>
        this.doctorService.getDoctors(term).pipe(
          tap((doctors) => {
            this.searchFailedDoctor = doctors.length === 0;
          }),
          catchError(() => {
            this.searchFailedDoctor = true;
            return of([]);
          }))
      ),
      tap(() => this.searchingDoctor = false)
    )

    //Editar paciente

    enableEditPatient  = () : void => {
      this.editPatient = true;

    }


    patientChangeEvent(patient) {
      this.editOrder.patchValue({
        patient
      });
      this.editPatient = false; // VERIFICARRRR
    }

    searchByCode(input){
      this.testService.getTestByCode(input.value).then( // HAY QUE FILTRAR
        result => {
          if(result.length == 0){
            this.searchFailed = true;
            setTimeout(()=> this.searchFailed = false, 1500)
          }
          if(result.length == 1){
            this.addTest(result[0])
          } // VER MULTIMATERIAL
          input.value = '';
  
        }
      )
    }

    showTestsDialog(){
  
      const ref = this.dialog.open(TestsDialog, {
        width: '50%',
      });
  
      ref.afterClosed().subscribe(
        data => {
          if(data.length >= 1){
            data.forEach(element => {
              this.addTest(element);
            });
          }
        }
      )
      
    }

    modifyOrder(){
      this.editOrder.enable();
      this.editOrder.get('ente').disable();

      let profiles = this.testsForm.controls.filter( 
        function(test){
          return this.indexOf(test.value.id)<0 && test.value.type == "P";
        },
        this.deletedTestsForm.controls.map(test => test.value.id)
       );

        
      this.orderEntryService.modifyOrder(this.editOrder.value, profiles).subscribe(
        resp => {console.log(resp)
          const ref = this.dialog.open(LabelsDialog, {
            width: '50%',
            data: {samples: resp, oldSamples: this.order.samples }
          });
    
          ref.afterClosed().subscribe(
            () => {
              this.router.navigate(['/order-entry/remittances', {search: true}])
            }
          )}
      )
    }

    modifyOrderType1(){
      this.editOrder.enable();
      this.editOrder.get('ente').disable();
    
      this.orderEntryService.samplesCalculationType1(this.editOrder.value).subscribe(
        data => {
          let lastSampleProgressive = 0;
          data.forEach(sample => {
            const oldSample = this.order.samples.filter(item => item.containerId == sample.containerId)[0];
            sample.tests.forEach(
              test => {
                test.toDelete = this.deletedTestsForm.controls.findIndex( dtest => (dtest.value.id == test.id || dtest.value.id == test.profileId )) > -1 ? true : false;
              }
            )
            if(oldSample != undefined){
              sample.disabled = true;
              sample.labelId = oldSample.labelId;
              sample.sampleProgressive = oldSample.sampleProgressive;
              if(oldSample.sampleProgressive > lastSampleProgressive)
                lastSampleProgressive = oldSample.sampleProgressive;
            } else{
              sample.sampleProgressive = ++lastSampleProgressive;
            }
          })
        
          const ref = this.dialog.open(LabelsInputDialog, {
            width: '50%',
            data: {samples: data, sampleCheck : this.group.sampleCheck}
          });
    
          ref.afterClosed().subscribe(
            (samples) => {
              //this.router.navigate(['/order-entry/remittances', {search: true}])
              if(samples){
                this.editOrder.addControl('samples', this.fb.array(samples));
                this.orderEntryService.modifyOrderType1(this.editOrder.value).subscribe((resp) => {
                  if (resp !== 0) {
                    this.router.navigate(['/order-entry/remittances', {search: true}])
                    //this.closeModal();
                    //alert('Su solicitud se ha cargado correctamente \n Su número de solicitud es: ' + resp);
                  }
                });
              }
              
            }
          )}
         )              
    }

    canSave(){
      return this.addedTestsForm.controls.length != 0 ||
              this.deletedTestsForm.controls.length != 0 ||
              (this.order.doctor.id != this.editOrder.value.doctor.id && this.editOrder.value.doctor.id) ||
              this.order.wardId != this.editOrder.value.ward.wardId ||
              (this.order.noteSector != this.editOrder.value.noteSector );
    }

    cancel(){
      this.router.navigate(['/order-entry/remittances', {search: true}])
    }

    addNotes(event){

      const dialogPosition: DialogPosition = {
        top: event.y + 'px',
        left: (event.x-500) + 'px'
      };
    
      const ref = this.dialog.open(NotesDialog, {
        width: '500px',
        data: this.editOrder.get('noteSector').value,
        position: dialogPosition,
      });
  
      ref.afterClosed().subscribe(
        data => this.editOrder.get('noteSector').setValue(data)
      )
  
    }

}
